import React, { Component } from "react";
import HeaderBar from "./header-bar/header-bar";
import { HeaderBarContainer } from "./header-bar/header-bar-container";

export default class EngineerManagment extends Component {
    render() {
        return (<HeaderBarContainer>
            <HeaderBar user={this.props.user} />
        </HeaderBarContainer>);
    }
}